export var Rating;
(function (Rating) {
    Rating[Rating["NOT_AT_ALL"] = 0] = "NOT_AT_ALL";
    Rating[Rating["NOT_VERY"] = 10] = "NOT_VERY";
    Rating[Rating["SOMEWHAT"] = 20] = "SOMEWHAT";
    Rating[Rating["VERY"] = 30] = "VERY";
    Rating[Rating["EXTREMELY"] = 40] = "EXTREMELY";
})(Rating || (Rating = {}));
;
//# sourceMappingURL=rating.enum.js.map